import { AccordionActionsProps, Button, Stack } from '@mui/material';

interface FormSectionActionsProps extends AccordionActionsProps {
  onNextClick: () => void;
  onBackClick?: () => void;
  nextDisabled?: boolean;
  backDisabled?: boolean;
}

export function FormSectionActions({ onNextClick, onBackClick, nextDisabled, backDisabled }: FormSectionActionsProps) {
  return (
    <Stack direction="row" spacing={2} alignSelf="flex-end">
      {onBackClick && (
        <Button onClick={onBackClick} variant="outlined" disabled={backDisabled}>
          Back
        </Button>
      )}
      {onNextClick && (
        <Button onClick={onNextClick} variant="contained" disabled={nextDisabled}>
          Next
        </Button>
      )}
    </Stack>
  );
}
